/** @format */
import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { _$, Button, Dialog } from '@king-design/react'
import { useHistory } from 'react-router'
import { ProductItem } from 'src/utils/interface'
import variable from 'src/static/styles/var'

// 自动跳转Prometheus的产品类型
export const PROMETHEUS_PRODUCT_TYPE = [28, 29] //, 70, 71

// 自动跳转延迟时间
const REDIRECT_DELAY = 10

interface RedirectPrometheusProps {
  currentProduct?: ProductItem
  editPolicyId?: string
}

// 跳转Prometheus的URL方法
export const getRedirectUrl = (productType: number) => {
  if (PROMETHEUS_PRODUCT_TYPE.includes(productType)) {
    return `/monitor/prometheusmonitor/alarm/edit?tab=policy&page=policy&productType=${productType}`
  } else {
    return `/monitor/alarmServer/rule/create/${productType}`
  }
}

const RedirectPrometheus: FC<RedirectPrometheusProps> = ({ currentProduct, editPolicyId }) => {
  const history = useHistory()
  const [visible, setVisible] = useState(false)
  const [countdown, setCountdown] = useState(REDIRECT_DELAY)
  const timerRef = useRef<ReturnType<typeof setInterval>>()

  const productType = currentProduct?.productType

  const redirectUrl = useMemo(
    () => `/monitor/prometheusmonitor/alarm/edit?tab=policy&page=policy&productType=${productType}`,
    [productType]
  )

  // 清除定时器
  const clearTimer = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current)
      timerRef.current = undefined
    }
  }, [])

  // 跳转Prometheus
  const handleRedirect = useCallback(() => {
    clearTimer()
    history.push(redirectUrl)
  }, [clearTimer, history, redirectUrl])

  // 判断是否需要自动跳转Prometheus
  useEffect(() => {
    if (!editPolicyId && productType && PROMETHEUS_PRODUCT_TYPE.includes(productType)) {
      setVisible(true)
      setCountdown(REDIRECT_DELAY)
      return
    }
    setVisible(false)
    clearTimer()
  }, [editPolicyId, productType, clearTimer])

  // 定时器
  useEffect(() => {
    clearTimer()
    if (!visible) {
      return
    }

    timerRef.current = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearTimer()
          history.push(redirectUrl)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return clearTimer
  }, [visible, redirectUrl, history, clearTimer])

  // 如果不需要自动跳转Prometheus，则不显示弹窗
  if (!visible) {
    return null
  }

  return (
    <Dialog
      value={visible}
      title={_$('前往Prometheus创建告警')}
      width={480}
      hideClose
      onChangeValue={show => {
        if (!show) {
          clearTimer()
          setVisible(false)
        }
      }}
      slotFooter={
        <Button type="primary" onClick={handleRedirect}>
          {_$('立即前往')}
        </Button>
      }
    >
      <p style={{ margin: 0, lineHeight: '22px' }}>
        {_$('该产品的告警策略需在Prometheus监控中配置，当前页面暂不支持创建。')}
      </p>
      <p style={{ margin: '8px 0 0', lineHeight: '22px' }}>
        {_$('将在')}
        <b style={{ color: variable.warningColor, margin: '0 4px' }}>{countdown}</b>
        {_$('秒后自动跳转，您也可点击按钮立即前往。')}
      </p>
    </Dialog>
  )
}

export default RedirectPrometheus
